import * as React from "react";
import { useState } from "react";
import Collapse from "@mui/material/Collapse";
import Paper from "@mui/material/Paper";
import FacilityGrid from "./FacilityGrid";
import FranchiseSummaryBand from "./FranchiseSummaryBand";

// One franchise group: the summary band with its facilities in a compact grid immediately below.
//
// Facilities are EXPANDED BY DEFAULT (design §3 rule 2). Collapse is a user action for tidying a
// long page, never a default used to save space -- the whole point of the grouped layout is that
// the facility grain stays visible, since that is where the warehouse/reporting configuration
// now lives. Collapse state is local and session-only.
export default function FranchiseGroup(props) {
  const franchise = props.franchise;
  const showActions = props.showActions;
  const bdmOptions = props.bdmOptions;
  const onSaveOwnership = props.onSaveOwnership;
  const onSaveDetails = props.onSaveDetails;
  const onSaveSite = props.onSaveSite;
  const onDeleteSite = props.onDeleteSite;
  const onSaveFranchiseDetails = props.onSaveFranchiseDetails;
  const onSaveFranchiseOwnership = props.onSaveFranchiseOwnership;
  const onSaved = props.onSaved;

  const [expanded, setExpanded] = useState(true);

  const handleToggle = () => setExpanded((wasExpanded) => !wasExpanded);

  return (
    <Paper variant="outlined" sx={{ mb: 2, overflow: "hidden" }}>
      <FranchiseSummaryBand
        franchise={franchise}
        expanded={expanded}
        onToggle={handleToggle}
        onSaveFranchiseDetails={onSaveFranchiseDetails}
        onSaveFranchiseOwnership={onSaveFranchiseOwnership}
        bdmOptions={bdmOptions}
        onSaved={onSaved}
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <FacilityGrid
          facilities={franchise.facilities}
          showActions={showActions}
          bdmOptions={bdmOptions}
          onSaveOwnership={onSaveOwnership}
          onSaveDetails={onSaveDetails}
          onSaveSite={onSaveSite}
          onDeleteSite={onDeleteSite}
          onSaved={onSaved}
        />
      </Collapse>
    </Paper>
  );
}
